import React, { useState } from "react";
import { Button, CircularProgress, Box } from "@mui/material";
import { AutoAwesome, Psychology, AutoMode } from "@mui/icons-material"; // Icons
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const AiUpdateButton = ({ handleAICall }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleClick = async () => {
    setLoading(true);
    try {
      // Await your function here
      await handleAICall();
    } catch (error) {
      console.error("AI Update Failed", error);
    } finally {
      // Ensure loading stops even if there is an error
      setLoading(false);
    }
  };

  return (
    <MDButton
      onClick={handleClick}
      disabled={loading}
      variant="contained"
      // Change the start icon based on loading state
      startIcon={
        loading ? (
          // Rotating AI Brain or simple spinner
          <AutoMode
            sx={{
              animation: "spin 2s linear infinite",
              "@keyframes spin": {
                "0%": {
                  transform: "rotate(0deg)",
                },
                "100%": {
                  transform: "rotate(360deg)",
                },
              },
            }}
          />
        ) : (
          <AutoAwesome />
        )
      }
      sx={{
        // AI Gradient Style (Purple to Blue)
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "#fff",
        fontWeight: "bold",
        textTransform: "none",
        padding: "10px 20px",
        borderRadius: "8px",
        boxShadow: "0 4px 15px rgba(118, 75, 162, 0.4)",
        transition: "all 0.3s ease-in-out",

        // Hover Effect: Glow stronger
        "&:hover": {
          background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
          boxShadow: "0 6px 20px rgba(118, 75, 162, 0.6)",
          transform: "translateY(-2px)",
        },

        // Disabled State (When loading)
        "&:disabled": {
          background: "#e0e0e0",
          color: "#9e9e9e",
          boxShadow: "none",
          cursor: "not-allowed",
        },
      }}
    >
      {/* {loading ? "Analyzing..." : "Ask AI for Insights"} */}
      {loading ? t("common.analyze") : t("common.askAI")}
    </MDButton>
  );
};

AiUpdateButton.propTypes = {
  handleAICall: PropTypes.func.isRequired,
};

export default AiUpdateButton;
